import { useState } from 'react'

import Tab from '@/components/view/atoms/tab/Tab'
import TabList from '@/components/view/atoms/tab/TabList'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import ExternalArticleDetailModalProvider from '@/components/container/modal/externalArticle/ExternalArticleDetailModalProvider'

import ExternalArticleListSection from './ExternalArticleListSection'
import ExternalArticleSettingsSection from './ExternalArticleSettingsSection'

// 外部記事コンテンツ（データ基盤 ＞ 外部記事コンテンツ）。Media-Driver・Reco-Media のどちらの契約でも使う。
// 特集ページマスタに載らない記事ページ（ページ管理機能の静的ページ・別ドメインのオウンドメディア等）を
// 特集ページと同じ構造で取り込み、Media-Driver・記事レコメンド・Findee・AIタグの対象にする。
type ArticleTab = 'list' | 'settings'

const ExternalArticlePage = () => {
  const [tab, setTab] = useState<ArticleTab>('list')

  return (
    <ExternalArticleDetailModalProvider>
      <Main type={MainLayoutType.FULL}>
        <PageTitle
          title='外部記事コンテンツ'
          description='特集ページマスタに載らない記事ページを取り込み、特集ページと併せて Media-Driver・記事レコメンド・Findee・AIタグの対象にします。記事ページが閲覧された時点で自動的に取り込みます。'
        />

        <Content>
          <Area>
            <TabList>
              <Tab selected={tab === 'list'} onClick={() => setTab('list')}>
                記事一覧
              </Tab>
              <Tab selected={tab === 'settings'} onClick={() => setTab('settings')}>
                取り込み設定
              </Tab>
            </TabList>
          </Area>

          {tab === 'list' ? <ExternalArticleListSection /> : <ExternalArticleSettingsSection />}
        </Content>
      </Main>
    </ExternalArticleDetailModalProvider>
  )
}

export default ExternalArticlePage
